import { atom } from "recoil";

export const pendingShipmentUpdatedFlagState = atom<boolean>({
  key: "pendingShipmentUpdatedFlagState",
  default: false,
});
